import React from 'react';

function Footer() {
  return (
    <footer className="Footer">
        <a href="https://www.supplay.fr/politique-de-confidentialite-supplay/">Politique de confidentialité</a>
        <a href="https://www.supplay.fr/politique-cookies-supplay/">Politique cookies</a>
        <a href="https://www.supplay.fr/mentions-legales-supplay/">Mentions légales</a>
        <a href="https://www.supplay.fr/conditions-generales-dutilisation/">Conditions générales d'utilisation</a>
        <span>©2024 Tous droits réservés Supplay</span>
      </footer>
  );
}

export default Footer;
